import React from "react";
import { observer } from "mobx-react";
import store from '../../../Stores/SurveyStore';
import SurveyCondensedTable from "../../../SurveyCondensedTable";
import { getOptionsArray, isUK } from "../../../../ibsHelper";
import ibsStore from '../../../Stores/IbsSurveyStore';
import { formDateReturnMonth } from "../../../../helpers";
import { SelectCombosIBS, NumberFormat } from "../../../../Enums/constants";
import { handleHOTChangeBenchmark, handleBenchmarkData, benchmarkCellRenderer, beforeKeyDownBenchmark, AddEmptyBenchmarkRow, getHiddenBenchmarkColumns } from "./BenchmarkTableHandler";

const BenchmarkTable = observer((props) => {
    return (
        <SurveyCondensedTable tableName={"Benchmark"}
            handleData={handleBenchmarkData}
            handleHOTChange={handleHOTChangeBenchmark}
            cellRenderer={benchmarkCellRenderer}
            beforeKeyDown={beforeKeyDownBenchmark}
            headers={["AssetClassCategoryName", "AssetClassName", "PolicyWeightPercent", "PolicyBenchmarkName", "PolicyReturnPercent", "PolicyReturnPercentMarch", "AssetMixPercent", "ExternalManagerCount", "Liability", "RowID", "del"]}
            columns={[
                { data: 'AssetClassCategoryName', readOnly: true },
                { data: 'AssetClassName', readOnly: true },
                { data: 'PolicyWeightPercent' },
                { data: 'PolicyBenchmarkName' },
                { data: 'PolicyReturnPercent' },
                { data: 'PolicyReturnPercentMarch' },
                { data: 'AssetMixPercent' },
                { data: 'ExternalManagerCount' },
                { data: 'IsLiabilityHedging', type: 'dropdown', source: getOptionsArray(SelectCombosIBS.LIABILITY_HEDGING) },
                { data: 'RowID' },
                { data: 'del', className: 'delCol' },
            ]}
            hideExtraColumns={getHiddenBenchmarkColumns}
            addEmptyRow={AddEmptyBenchmarkRow}
            colWidths={['0px', '150px', '105px', '400px', '105px', '105px', '95px', '152px', '160px', '75px', '50px']}
            hiddenColumns={(ibsStore.checkMandateLevel > 0 || isUK()) ? [7] : []}
            formatting={['', '', NumberFormat.PERCENTAGE, '', NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.INTEGER, '', '']}
            nestedHeaders={[
                ['', `Asset class`,
                    'Policy<br/>weight %',
                    'Benchmark description',
                    'Benchmark<br/>return %',
                    'Benchmark<br/>return %',
                    'Effective<br/>asset mix %',
                    '# of External<br/>active mandates', 'Liability Hedging', 'test']
            ]}
            trimDropdowns={true}
            helpText={["", "Asset class <br/><br/> Select the asset class categories and styles that best match your mandates. For example, if all of your equity mandates are Global, then EAFE, etc do not apply.",
                "Policy weight % <br/><br/> Policy weights reflect long-term policy, normal or target asset mix such as 60% equities and 40% bonds and must add to 100%. If your policy weight is expressed in ranges, use midpoints. policy weights should be provided as at the end of the year.",
                "Benchmark description <br/><br/> Benchmarks are broad investable capital market indexes (for example, the S&P500 as U.S. stocks) against which asset class performance is measured. If your fund has more than one asset class benchmark, indicate each benchmark and its appropriate weight (such as 60% S&P500, 40% Russell 3000)",
                "Benchmark return <br/><br/> Provide benchmark returns for the year ended " + formDateReturnMonth(store?.currentYear) + ". If you engage in currency hedging and hedging is done at the asset class level provide hedged returns and benchmarks. If hedging is done at the total portfolio level provide unhedged returns and benchmarks.",
                "",
                "",
                "Number of External active manager mandates <br/><br/> An active mandate is defined as assets given to an external manager to manage per a set of objectives and constraints. For private asset classes, both pooled funds and limited partnerships should be counted as mandates. Each external manager relationship is equal to at least one mandate. But it is possible to have multiple mandates with the same manager. For example, you might have a US equity mandate and an EAFE equity mandate with the same manager. Similarly, you may have participated in multiple limited partnerships with the same private equity manager.",
                "Liability Hedging <br/> <br/> Identify liability hedging for your asset classes. Leave the cell empty for asset classes where liability hedging doesn't apply."]}
            addRowBtnName={"Add Benchmark"}
        />
    );

});
export default BenchmarkTable;

